import React, { useState, useEffect } from 'react'
import Breadcrumb from '../breadcrumb/breadcrumb.component'
import { Formik } from 'formik'
import Yup from '../../../../helpers/custom-yup'
import Conclusion from './conclusion.component'
import Topo from '../topo/topo.component'
import DocumentRG from './document-rg.component'
import DocumentCPF from './document-cpf.component'
import Phone from './phone.component'
import { AuthenticationService } from '../../../../services/authentication.service'

const Main = props => {
	const [rg, setRg] = useState(0)
	const [cpf, setCpf] = useState(0)
	const [step, setStep] = useState(0)
	const [phone, setPhone] = useState(0)
	const { hideLoading, showLoading, providerSignupData, userLogin } = props

	useEffect(() => {
		setStep(1)
	}, [])

	function handleSetCpf(value) {
		setCpf(value)
	}
	function handleSetPhone(value) {
		setPhone(value)
	}
	function handleSetRg(value) {
		setRg(value)
	}
	function nextStep() {
		if (step < 4)
			setStep(step + 1)
	}

	function prevStep() {
		if (step > 0) {
			setStep(step - 1)
		}
	}

	const schema = Yup.object().shape({
		cpf: Yup.string()
			.required('Informe o CPF')
			.cpf()
			.nullable()
	})

	const initialValues = {
		rg: '',
		cpf: '',
		phone: ''
	}

	const handleCreateUser = () => {
		if (rg && cpf && phone && providerSignupData) {
			showLoading();
			const obj = { rg, phone, cpf, email: providerSignupData.email, name: providerSignupData.name }

			AuthenticationService.loginSocialClientRegister(obj).then(data => {
				if (data.success) {
					userLogin(data.data)
					hideLoading()
				} else {
					hideLoading()
				}
			})
		}
	}


	return (
		providerSignupData ? (
			<section>
				<Topo step={step} name={providerSignupData.name} />
				<Breadcrumb step={step} />
				<Formik
					validationSchema={schema}
					initialValues={initialValues}
					onSubmit={(action) => {
						action.resetForm()
					}}>
					{props => (
						<form onSubmit={props.handleSubmit} autoComplete="off">
							{step === 1 && (
								<DocumentCPF
									{...props}
									nextStep={nextStep}
									showLoading={showLoading}
									hideLoading={hideLoading}
									handleSetCpf={handleSetCpf}
									providerSignupData={providerSignupData}
								/>
							)}
							{step === 2 && (
								<DocumentRG
									{...props}
									nextStep={nextStep}
									prevStep={prevStep}
									showLoading={showLoading}
									hideLoading={hideLoading}
									handleSetRg={handleSetRg}
									providerSignupData={providerSignupData}
								/>
							)}
							{step === 3 && (
								<Phone
									{...props}
									nextStep={nextStep}
									prevStep={prevStep}
									showLoading={showLoading}
									hideLoading={hideLoading}
									handleSetPhone={handleSetPhone}
									providerSignupData={providerSignupData}
								/>
							)}
							{step === 4 && (
								<Conclusion
									{...props}
									providerSignupData={providerSignupData}
									handleCreateUser={handleCreateUser}
								/>
							)}
						</form>
					)}
				</Formik>
			</section>
		) : null
	)
}

export default Main
